import { render, staticRenderFns } from "./MailvelopeEditor.vue?vue&type=template&id=17d2a4b0&scoped=true&"
import script from "./MailvelopeEditor.vue?vue&type=script&lang=js&"
export * from "./MailvelopeEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailvelopeEditor.vue?vue&type=style&index=0&id=17d2a4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2a4b0",
  null
  
)

export default component.exports